import axios from 'axios'
import { verificarTokenAutenticacao } from '../../middleware/Token'

const BASEURLZAI = axios.create({
    baseURL: process.env.REACT_APP_API_ZAI,
    headers: {
        'Content-Type': 'application/json'
    }
})

BASEURLZAI.interceptors.request.use(async config => {
    const token = verificarTokenAutenticacao()

    if (token) config.headers.Authorization = `Bearer ${token}`

    return config
})

export default BASEURLZAI
